import Joi from 'joi';
const fullObject = Joi.object({
  type: Joi.string().allow('', null),
  code: Joi.string().allow('', null),
  data: Joi.string().allow('', null),
  title: Joi.string().allow('', null),
  description: Joi.string().allow('', null),
  poster: Joi.string().allow('', null)
}).unknown(true);
const mediaFullSchema = (isOptional = false) => isOptional ? Joi.object({
  desktop: fullObject.allow(null),
  tablet: fullObject.allow(null),
  mobile: fullObject.allow(null)
}) : Joi.object({
  desktop: fullObject,
  tablet: fullObject,
  mobile: fullObject
});
export default mediaFullSchema;